import { selectHistoryDocuments, encounterDate } from './historyEvidence';
import { getDocument, getDocumentsByType, getDocuments } from "./firestoreService";

export const fetchDocumentData = async (patientId, docId, setPersonName, setDocumentData, setTitle, setDocumentHistory, setDocumentOld) => {
  try {
    const patientData = await getDocument(`patients`, patientId);

    const limitDocuments = false; // this will be a user setting later. For now, use all documents for history.

    if (patientData) {
      const formattedPersonName = `${patientData.firstName} ${patientData.lastName}`;
      if (typeof setPersonName === "function") {
        setPersonName(formattedPersonName);
      }

      const documentData = await getDocument(`patients/${patientId}/documents`, docId);

      if (documentData && !documentData.isArchived) {

        setDocumentData(documentData);

      
        if ("document_summary" in documentData) {
          //old data format handling - this can be retired, as all documents should have a document summary
          const summaryType = typeof documentData.document_summary;
          if (summaryType === "string") {
            setDocumentOld(true);
          } else {
            setDocumentOld(false);
          }
        } else {
          setDocumentOld(false);
        }

        if (typeof setTitle === "function") {
          setTitle(documentData.title);
        }

        let previousDocuments;

        if ((documentData.typeId === 1 || documentData.typeId === 2) && limitDocuments) {
          //limits to current audio recorded docs
          const previousDocumentsType1 = await getDocumentsByType(`patients/${patientId}/documents`, 1);
          const previousDocumentsType2 = await getDocumentsByType(`patients/${patientId}/documents`, 2);
          previousDocuments = [...previousDocumentsType1, ...previousDocumentsType2];
        } else {
          previousDocuments = await getDocuments(`patients/${patientId}/documents`);
        }
        const filteredDocuments = selectHistoryDocuments(previousDocuments, {
          excludeDocumentId: docId, beforeDate: encounterDate(documentData.documentDate),
        });
        // An empty result must replace history retained from an earlier refresh.
        setDocumentHistory(filteredDocuments);

        // Return the fetched data
        return {
          personName: `${patientData?.firstName} ${patientData?.lastName}`,
          documentData,
          title: documentData?.title,
          documentHistory: filteredDocuments,
          documentOld: typeof documentData?.short_summary === "string" || typeof documentData?.document_summary === "string",
        };
      } else {
        console.error(`[fetchDocumentData] Document not found or archived`, {
          patientId,
          docId,
          isArchived: documentData?.isArchived === true,
        });
        return { notFound: true };
      }
    } else {
      console.error(`[fetchDocumentData] Patient not found`, {
        patientId,
      });
      return null;
    }
  } catch (error) {
    console.error(`[fetchDocumentData] Error fetching document data:`, {
      error: error.message,
      stack: error.stack,
      patientId,
      docId,
    });
    return null;
  }
};
